<div class="page-content">
  <div class="container">
    <p style="text-align: center; font-size: 40px; font-weight: 500; margin-top: 20px">
      {{ 'SFO_GiftcardDetails' | t | async }}
    </p>
    <hr
      style="
        height: 2.5px;
        border: none;
        margin-top: 40px;
        margin-bottom: 40px;
        background: -webkit-gradient(
          linear,
          0 0,
          100% 0,
          from(transparent),
          to(transparent),
          color-stop(50%, var(--primary-application-color))
        );
      " />
  </div>
  <div
    class="page-content wireframe2 fadeBody"
    style="background-color: white; padding: 5px; margin-left: 15%; margin-right: 15%">
    <div *ngIf="!ShowGiftcard" class="container">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <h2 class="col-lg-3 text-center">{{ 'SFO_EnterPasshrase' | t | async }}</h2>
        </div>
        <div class="form-row">
          <div class="col-lg-3 text-center">
            <input
              style="width: 250px"
              class="form-control text-center input-lg"
              name="Passphrase"
              [placeholder]="'SFO_GiftcardCode' | t | async"
              autocomplete="Passphrase"
              formControlName="passphrase" />
          </div>
        </div>
        <div *ngIf="form.errors">
          <div class="alert alert-dange text-center" role="alert">
            <p *ngIf="form.errors?.notFound; else AnErrorMessage">{{ 'SFO_GiftCardNotFound' | t | async }}</p>
            <ng-template #AnErrorMessage>
              <p>{{ 'SFO_GiftCardError' | t | async }}</p>
            </ng-template>
          </div>
        </div>
        <div class="form-row">
          <div class="col-lg-3 text-center">
            <button type="submit" class="btn btn-primary with-shadow">
              {{ 'SFO_FindGiftCard' | t | async }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="ShowGiftcard" class="container">
      <div class="section">
        <div class="row">
          <div class="col l6">
            <h2>
              <i class="fas fas fa-gifts"></i><span class="v-middle">{{ 'SFO_GiftCard' | t | async }}</span>
            </h2>
            <p class="content-section">{{ GiftCardName }}</p>
          </div>
          <div class="col l6">
            <h2>
              <i class="fas fa-id-card-alt"></i><span class="v-middle">{{ 'SFO_GiftCardNumber' | t | async }}</span>
            </h2>
            <p class="content-section">{{ GiftCardNumber }}</p>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="row">
          <div class="col l6">
            <h2>
              <i class="fas fa-hand-holding-usd"></i><span class="v-middle">{{ 'SFO_GiftCardValue' | t | async }}</span>
            </h2>
            <p class="content-section">
              {{ GiftCardAmount | number }}
              {{ HotelCurrency }}
            </p>
          </div>
          <div class="col l6">
            <h2>
              <i class="fas fa-calendar-alt"></i
              ><span class="v-middle">{{ 'SFO_GiftCardDateOfPurchase' | t | async }}</span>
            </h2>
            <p class="content-section">
              {{ GiftCardCreated }}
            </p>
          </div>
        </div>
      </div>
      <div style="height: 15vh"></div>
      <div class="text-center">
        <div class="text-center2">
          <button
            *ngIf="CanOpenPdf; else disabledButton"
            type="button"
            class="btn btn-primary with-shadow"
            (click)="openGiftCardLink()">
            {{ 'SFO_GiftCardClickHereToSee' | t | async }}
          </button>
          <ng-template #disabledButton>
            <span class="text-danger">{{ 'SFO_GiftCardErrorNotViewable' | t | async }}</span>
            <!--<a class="btn btn-primary disabled with-shadow">{{ 'SFO_GiftCardClickHereToSee' | t | async }}</a>-->
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
